 <!--  <div class="ui-g-6 ui-md-6 d-flex">
    <div class="ui-g-1 p-0" class="checkbox-estado-etiqueta-wrapper" style="min-width:24px;">
        <input type="checkbox" *ngIf="!etiqueta.obligatorio" [(ngModel)]="etiqueta.estado">
    </div>
    <div class="ui-g-10 p-0">
        <ng-content></ng-content>
    </div>
</div> -->

<div class="ui-g-6 ui-md-6 d-flex">
  <div class="ui-g-1 p-0 checkbox-estado-etiqueta-wrapper" style="min-width:24px;">
    <!-- Checkbox: obligatorio o no -->
    <input
      type="checkbox"
      *ngIf="etiqueta.obligatorio"
      checked
      disabled
    />
    <input
      type="checkbox"
      *ngIf="!etiqueta.obligatorio"
      [(ngModel)]="etiqueta.estado"
    />
  </div>
  <div class="ui-g-10 p-0">
    <ng-content></ng-content>
  </div>
</div>
